// Turkish + English translations for YGS site
export const translations = {
  tr: {
    nav: {
      home: "Ana Sayfa",
      products: "Ürünler",
      services: "Hizmetler",
      references: "Referanslar",
      about: "Hakkımızda",
      contact: "İletişim",
      getQuote: "Teklif Al",
    },
    hero: {
      eyebrow: "Endüstriyel Güvenlik · Otomasyon · Kapı Sistemleri",
      title1: "Sessiz",
      title2: "ama güçlü.",
      subtitle:
        "YGS Yapı Güvenlik Sistemleri; otomatik kapı, kepenk ve endüstriyel açılış sistemlerinde Türkiye genelinde sektör lideri çözümler sunar.",
      ctaPrimary: "Ücretsiz Keşif",
      ctaSecondary: "Ürünleri İncele",
      tickerTitle: "Güvenilir markalar",
    },
    stats: {
      heading: "Sayılarla YGS",
      sub: "İki dekadı aşan tecrübe, binlerce başarıyla tamamlanmış proje.",
      items: [
        { value: "20+", label: "Yıllık Deneyim" },
        { value: "2.500+", label: "Tamamlanan Proje" },
        { value: "81", label: "İl Genelinde Hizmet" },
        { value: "%99,8", label: "Müşteri Memnuniyeti" },
      ],
    },
    products: {
      eyebrow: "Ürün Kategorileri",
      heading: "Her ihtiyaca uygun, sertifikalı sistemler",
      sub: "Otomatik kapılardan endüstriyel kapılara kadar geniş bir ürün yelpazesi. CE, TSE ve EN normlarına %100 uyum.",
      learnMore: "Detaylı Bilgi",
      cards: [
        {
          key: "automatic",
          title: "Otomatik Kapılar",
          desc: "Cam, fotoselli, döner ve hermetik tipte sessiz çalışan otomatik kapı sistemleri.",
          features: ["Sessiz motor", "Acil durum açılımı", "Sensör entegrasyonu", "10 yıl garanti"],
        },
        {
          key: "shutters",
          title: "Kepenk Sistemleri",
          desc: "Hırsızlığa ve darbeye dayanıklı motorlu kepenkler; ofis, mağaza ve depolar için.",
          features: ["Çelik panel", "Sessiz motor", "Akıllı kontrol", "Acil aydınlatma"],
        },
        {
          key: "industrial",
          title: "Endüstriyel Kapılar",
          desc: "Yüksek devirli seksiyonel ve hızlı PVC endüstriyel kapı çözümleri.",
          features: ["Hızlı açılım", "Termal yalıtım", "Ağır hizmet", "Modüler yapı"],
        },
      ],
    },
    services: {
      eyebrow: "Hizmetlerimiz",
      heading: "Anahtar teslim, A'dan Z'ye süreç yönetimi",
      sub: "Sahada keşiften 7/24 servise kadar uçtan uca hizmet zinciri.",
      items: [
        { title: "Keşif & Projelendirme", desc: "Sahada ücretsiz keşif, ölçü, statik analiz ve teknik proje hazırlama." },
        { title: "Üretim", desc: "Avrupa standartlarında özel ölçü üretim, kalite kontrol ve test laboratuvarı." },
        { title: "Montaj & Devreye Alma", desc: "Sertifikalı ekiplerle hızlı kurulum, kontrol ve eğitim." },
        { title: "7/24 Servis", desc: "Türkiye genelinde 4 saat içinde müdahale garantili teknik destek." },
        { title: "Bakım Sözleşmeleri", desc: "Periyodik bakım, yedek parça ve performans raporlama hizmetleri." },
        { title: "Uzaktan İzleme", desc: "IoT tabanlı uzaktan izleme ve kestirimci bakım altyapısı." },
      ],
    },
    references: {
      eyebrow: "Referanslar",
      heading: "Türkiye'nin önde gelen markaları YGS'yi tercih ediyor",
      sub: "İnşaat, lojistik, sağlık ve perakende sektörünün öncü markaları için iş ortaklığı yapıyoruz.",
    },
    faq: {
      eyebrow: "Sıkça Sorulan Sorular",
      heading: "Aklınızdaki sorular için kısa cevaplar",
      items: [
        { q: "Keşif ücretli mi?", a: "Hayır. Türkiye genelinde keşif tamamen ücretsizdir. Talebinizi ilettiğinizde 24 saat içinde sahada oluyoruz." },
        { q: "Garanti süreniz ne kadar?", a: "Tüm sistemlerimizde standart garanti süresi 24 aydır; otomatik kapılarda mekanik aksam için 10 yıla kadar uzatılabilir." },
        { q: "Yedek parça stoklarınız var mı?", a: "Evet, İstanbul'daki ana lojistik merkezimizde 5.000+ kalemlik yedek parça envanteri bulunmaktadır." },
        { q: "Bakım sözleşmesi nasıl ilerliyor?", a: "Yıllık 2/4/6 ziyaret seçenekleri sunuyoruz. Her ziyaret sonrası dijital bakım raporu paylaşılır." },
        { q: "Mevcut sistemleri yeniliyor musunuz?", a: "Evet, mevcut otomatik kapı ve kepenk sistemlerini modernize ediyor; motor, kontrol ve sensör yenileme yapıyoruz." },
        { q: "Hangi şehirlerde hizmet veriyorsunuz?", a: "81 il genelinde aktif servis ağımız bulunmaktadır. Detay için bize ulaşın." },
      ],
    },
    about: {
      eyebrow: "Hakkımızda",
      heading: "20 yılı aşkın süredir mühendislik ve güvenliği aynı çatıda buluşturuyoruz",
      p1: "YGS Yapı Güvenlik Sistemleri, 2003 yılında İstanbul'da kurulmuş; otomatik kapı, kepenk ve endüstriyel kapı sistemlerinde uzmanlaşmış bir mühendislik şirketidir.",
      p2: "Sertifikalı ekibimiz, üretim tesisimiz ve geniş servis ağımızla; ofislerden lojistik merkezlerine, hastanelerden alışveriş merkezlerine kadar her ölçekte projeye çözüm sunarız.",
      bullets: [
        "ISO 9001 & ISO 45001 sertifikalı üretim",
        "CE ve TSE uyumlu sistemler",
        "Türkiye'nin 81 ilinde servis ağı",
        "120+ uzman saha ekibi",
      ],
    },
    contact: {
      eyebrow: "İletişim",
      heading: "Projeniz için özel teklif alın",
      sub: "WhatsApp veya telefon ile ulaşın, teknik ekibimiz en kısa sürede yanıt versin.",
      address: "Adres",
      callUs: "Bizi Arayın",
      mailUs: "E-posta",
    },
    footer: {
      tagline: "Sessiz ama güçlü güvenlik sistemleri.",
      products: "Ürünler",
      company: "Şirket",
      legal: "Bilgilendirme",
      kvkk: "KVKK Aydınlatma Metni",
      privacy: "Gizlilik Politikası",
      copyright: "© 2025 YGS Yapı Güvenlik Sistemleri. Tüm hakları saklıdır.",
    },
    admin: {
      title: "YGS Yönetim Paneli",
      login: "Giriş Yap",
      email: "E-posta",
      password: "Şifre",
      logout: "Çıkış",
      tabs: { contacts: "Talepler", references: "Referanslar", settings: "Site Ayarları" },
    },
  },
  en: {
    nav: {
      home: "Home",
      products: "Products",
      services: "Services",
      references: "References",
      about: "About",
      contact: "Contact",
      getQuote: "Get a Quote",
    },
    hero: {
      eyebrow: "Industrial Security · Automation · Door Systems",
      title1: "Quiet,",
      title2: "but powerful.",
      subtitle:
        "YGS Building Security Systems delivers industry-leading automatic doors, shutters, and industrial gate solutions across Turkey.",
      ctaPrimary: "Free Site Visit",
      ctaSecondary: "Explore Products",
      tickerTitle: "Trusted brands",
    },
    stats: {
      heading: "YGS in numbers",
      sub: "Over two decades of expertise. Thousands of successfully delivered projects.",
      items: [
        { value: "20+", label: "Years of Experience" },
        { value: "2,500+", label: "Completed Projects" },
        { value: "81", label: "Cities Covered" },
        { value: "99.8%", label: "Customer Satisfaction" },
      ],
    },
    products: {
      eyebrow: "Product Categories",
      heading: "Certified systems for every need",
      sub: "From automatic doors to industrial gates. 100% compliant with CE, TSE and EN norms.",
      learnMore: "Learn more",
      cards: [
        {
          key: "automatic",
          title: "Automatic Doors",
          desc: "Sliding glass, sensor, revolving and hermetic automatic door systems with whisper-quiet motors.",
          features: ["Quiet motor", "Emergency open", "Sensor integration", "10-year warranty"],
        },
        {
          key: "shutters",
          title: "Roller Shutters",
          desc: "Burglar- and impact-resistant motorized shutters for offices, retail and warehouses.",
          features: ["Steel panel", "Quiet motor", "Smart control", "Emergency lighting"],
        },
        {
          key: "industrial",
          title: "Industrial Doors",
          desc: "High-speed sectional and rapid PVC industrial door solutions.",
          features: ["Rapid opening", "Thermal insulation", "Heavy duty", "Modular build"],
        },
      ],
    },
    services: {
      eyebrow: "Our Services",
      heading: "Turn-key, end-to-end project management",
      sub: "From on-site discovery to 24/7 service, a full service chain.",
      items: [
        { title: "Survey & Engineering", desc: "Free on-site survey, measurement, structural analysis and technical drawings." },
        { title: "Manufacturing", desc: "European-standard custom production, QC and a full test lab." },
        { title: "Installation & Commissioning", desc: "Certified teams, fast deployment, inspection and training." },
        { title: "24/7 Service", desc: "Guaranteed 4-hour on-site response across Turkey." },
        { title: "Maintenance Contracts", desc: "Periodic maintenance, spare parts and performance reporting." },
        { title: "Remote Monitoring", desc: "IoT-based remote monitoring and predictive maintenance." },
      ],
    },
    references: {
      eyebrow: "References",
      heading: "Leading brands across Turkey choose YGS",
      sub: "We partner with leaders in construction, logistics, healthcare and retail.",
    },
    faq: {
      eyebrow: "Frequently Asked Questions",
      heading: "Quick answers to common questions",
      items: [
        { q: "Are site visits free?", a: "Yes. Site visits are entirely free across Turkey. We are on-site within 24 hours of your request." },
        { q: "What's your warranty period?", a: "Standard warranty is 24 months on all systems; mechanical parts on automatic doors can be extended up to 10 years." },
        { q: "Do you stock spare parts?", a: "Yes, our Istanbul logistics hub stocks 5,000+ spare-part SKUs." },
        { q: "How does the maintenance contract work?", a: "We offer 2/4/6 visits per year with a digital report after every visit." },
        { q: "Do you modernize existing systems?", a: "Yes, we modernize existing automatic doors and shutters: motor, controller and sensor upgrades." },
        { q: "Which cities do you serve?", a: "We have an active service network across all 81 provinces. Contact us for details." },
      ],
    },
    about: {
      eyebrow: "About Us",
      heading: "20+ years of engineering and security under one roof",
      p1: "YGS Building Security Systems, founded in Istanbul in 2003, is an engineering company specialized in automatic doors, roller shutters and industrial doors.",
      p2: "Our certified team, in-house manufacturing and broad service network deliver solutions for projects of every scale — from offices to logistics hubs, hospitals to shopping malls.",
      bullets: [
        "ISO 9001 & ISO 45001 certified manufacturing",
        "CE and TSE compliant systems",
        "Service network across all 81 provinces",
        "120+ certified field engineers",
      ],
    },
    contact: {
      eyebrow: "Contact",
      heading: "Get a custom quote for your project",
      sub: "Reach us on WhatsApp or by phone — our technical team will respond as soon as possible.",
      address: "Address",
      callUs: "Call us",
      mailUs: "Email us",
    },
    footer: {
      tagline: "Quiet but powerful security systems.",
      products: "Products",
      company: "Company",
      legal: "Legal",
      kvkk: "KVKK Notice",
      privacy: "Privacy Policy",
      copyright: "© 2025 YGS Building Security Systems. All rights reserved.",
    },
    admin: {
      title: "YGS Admin Panel",
      login: "Sign in",
      email: "Email",
      password: "Password",
      logout: "Logout",
      tabs: { contacts: "Submissions", references: "References", settings: "Site Settings" },
    },
  },
};
